import * as actionTypes from "../../actionLabels/index";
const initialState = {
  getAllTaxInvoice: [],
  getAllTaxInvoiceBuyer: [],
  getAllTaxInvoiceGen: [],
  getAllTaxInvoiceSale: [],
  getAllTaxInvoiceLot: [],
  getAllTaxInvoiceSession: [],
  invoiceById: [],
  exportedFile: [],
  isExported: false,
  gstById: [],
  excelById: [],
  exportDataSeller: [],
  exportDataSellerApiCall: [],
  InvoiceApiStatus: false,
  ApiStatusRep: false,
  isApiCalled: false,
  isInvoiceGenerateButtonDisabled: false,
  isSearchDisabled: false,
  isSearchIndividualTaxDisabled : false,
  isExportIrnDetail: false,
};

const getTaxInvoiceReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_ALL_TAX_INVOICE_SUCCESS:
      return {
        ...state,
        getAllTaxInvoice: action.payload,
        error: null,
      };
    case actionTypes.GET_ALL_TAX_INVOICE_FAIL:
      return {
        ...state,
        getAllTaxInvoice: [],
        error: action.payload,
      };

    case actionTypes.GET_ALL_TAX_INVOICE_SUCCESS_BUYER:
      return {
        ...state,
        getAllTaxInvoiceBuyer: action.payload,
        error: null,
      };
    case actionTypes.GET_ALL_TAX_INVOICE_FAIL_BUYER:
      return {
        ...state,
        getAllTaxInvoiceBuyer: [],
        error: action.payload,
      };

    case actionTypes.GET_ALL_TAX_INVOICE_GEN_SUCCESS:
      return {
        ...state,
        getAllTaxInvoiceGen: action.payload,
        error: null,
      };
    case actionTypes.GET_ALL_TAX_INVOICE_GEN_FAIL:
      return {
        ...state,
        getAllTaxInvoiceGen: [],
        error: action.payload,
      };

    case actionTypes.GET_ALL_TAX_INVOICE_SALE_SUCCESS:
      return {
        ...state,
        getAllTaxInvoiceSale: action.payload,
        error: null,
      };
    case actionTypes.GET_ALL_TAX_INVOICE_SALE_FAIL:
      return {
        ...state,
        getAllTaxInvoiceSale: [],
        error: action.payload,
      };

    case actionTypes.GET_ALL_TAX_INVOICE_LOT_SUCCESS:
      return {
        ...state,
        getAllTaxInvoiceLot: action.payload,
        error: null,
      };
    case actionTypes.GET_ALL_TAX_INVOICE_LOT_FAIL:
      return {
        ...state,
        getAllTaxInvoiceLot: [],
        error: action.payload,
      };
    case actionTypes.GET_INVOICE_BY_ID_SUCCESS:
      return {
        ...state,
        invoiceById: action.payload,
        error: null,
      };

    case actionTypes.GET_INVOICE_BY_ID_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case actionTypes.EXPORTED_FILE_SUCCESS:
      return {
        ...state,
        exportedFile: action.payload,

      }

    case actionTypes.EXPORTED_FILE_FAILURE:
      return {
        ...state,
        error: action.payload
      }

      case actionTypes.EXPORTED_FILE_API_CALL:
        return{
          ...state,
          isExported: true
        }

        case actionTypes.RESET_EXPORTED_FILE:
          return{
            ...state,
            isExported:false
          }

    case actionTypes.GET_ALL_TAX_INVOICE_SESSION_SUCCESS:
      return {
        ...state,
        getAllTaxInvoiceSession: action.payload,
        error: null,
      };
    case actionTypes.GET_ALL_TAX_INVOICE_SESSION_FAIL:
      return {
        ...state,
        getAllTaxInvoiceSession: [],
        error: action.payload,
      };

    case actionTypes.GET_INVOICE_GST_BY_ID_SUCCESS:
      return {
        ...state,
        gstById: action.payload,
        error: null,
      };

    case actionTypes.GET_INVOICE_GST_BY_ID_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case actionTypes.GET_GST_EXCEL_BY_ID_SUCCESS:
      return {
        ...state,
        isApiCalled: true,
        excelById: action.payload,
        error: null,
      };

    case actionTypes.GET_GST_EXCEL_BY_ID_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case actionTypes.GET_EXPORT_DATA_SELLER_SUCCESS:
      return {
        ...state,
        exportDataSeller: action.payload,
        error: null,
      };
    case actionTypes.GET_EXPORT_DATA_SELLER_FAIL:
      return {
        ...state,
        exportDataSeller: "",
        error: action.payload,
      };
    case actionTypes.GET_EXPORT_DATA_SELLER_API_CALL:
      return {
        ...state,
        exportDataSellerApiCall: action.payload,
        error: action.payload,
      };

    case actionTypes.INVOICE_API_STATUS:
      return {
        ...state,
        InvoiceApiStatus: action.payload.data,
      };

    case actionTypes.API_STATUS_RESPONSE:
      return {
        ...state,
        ApiStatusRep: action.payload.data,
      };

    case actionTypes.DISABLE_INVOICE_GENERATE_BUTTON:
      console.log("Button Disabled");
      return {
        ...state,
        isInvoiceGenerateButtonDisabled: true,
      };


    case actionTypes.ENABLE_INVOICE_GENERATE_BUTTON:
      console.log("Button Enabled");
      return {
        ...state,
        isInvoiceGenerateButtonDisabled: false,
      };

    case actionTypes.DISABLE_SEARCH_BUTTON:
      return {
        ...state,
        isSearchDisabled: true,
      };
    case actionTypes.ENABLE_SEARCH_BUTTON:
      return {
        ...state,
        isSearchDisabled: false,
      };

    case actionTypes.DISABLE_INDIVIDUALBUYER_TAXINVOICE_SEARCH_BUTTON:
      return {
        ...state,
        isSearchIndividualTaxDisabled: true,
      };
    case actionTypes.ENABLE_INDIVIDUALBUYER_TAXINVOICE_SEARCH_BUTTON:
      return {
        ...state,
        isSearchIndividualTaxDisabled: false,
      };

    case actionTypes.DISABLE_EXPORT_IRN_DETAILS_BUTTON:
      return {
        ...state,
        isExportIrnDetail: true,
      };

    case actionTypes.ENABLE_EXPORT_IRN_DETAILS_BUTTON:
      return {
        ...state,
        isExportIrnDetail: false,
      };

    case actionTypes.DISABLE_IRN_UPLOAD_DOCUMENT_BUTTON:
      return {
        ...state,
        isIRNUploadDocumentDisabled: true,
      }

    case actionTypes.ENABLE_IRN_UPLOAD_DOCUMENT_BUTTON:
      return {
        ...state,
        isIRNUploadDocumentDisabled: false,
      }

    default:
      return state;
  }
};

export default getTaxInvoiceReducer;
